import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { SapEccLinkedService } from 'app/model/linkedservice/sap-ecc.linkedservice';
import { passwordOrAKVtoSecretBase, secretBaseToPasswordOrAKV } from 'app/model/adapters/linkedservices/azure-key-vault.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SapEccLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                url: '*',
                username: '*',
                password: 'secret',
                encryptedCredential: '*'
            }
        }
    }
})
export class SapEccLinkedServiceAdapter extends LinkedServiceAdapter<SapEccLinkedService> {
    protected modelConstructor(): new () => SapEccLinkedService {
        return SapEccLinkedService;
    }

    protected model(): IModel {
        return SapEccLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: SapEccLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.SapEccLinkedService;
        properties.type = Metamodel.modelFor(SapEccLinkedService).name;
        const password: Model.SecretBase = passwordOrAKVtoSecretBase(linkedService.password, this.context);
        properties.typeProperties = {
            url: linkedService.url,
            username: linkedService.username,
            password
        };

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: SapEccLinkedService): Promise<SapEccLinkedService> {
        const prop = linkedServiceResource.properties as Model.SapEccLinkedService;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const typeProperties: Model.SapEccLinkedServiceTypeProperties = prop.typeProperties;

        linkedService.url = typeProperties.url;
        linkedService.username = typeProperties.username;
        linkedService.password = secretBaseToPasswordOrAKV(typeProperties.password, true, this.context);
        return linkedService;
    }
}
